import React, {
  createContext,
  FC,
  PropsWithChildren,
  ReactNode,
  useContext,
  useMemo,
} from 'react';

type AIAgentsHubContextType = {
  setAction: React.Dispatch<React.SetStateAction<ReactNode>>;
  action: ReactNode;
};

const AIAgentsHubContext = createContext<AIAgentsHubContextType | null>(null);

export const AIAgentsHubProvider: FC<
  PropsWithChildren<{
    action: ReactNode;
    setAction: React.Dispatch<React.SetStateAction<ReactNode>>;
  }>
> = ({ children, action, setAction }) => {
  const value: AIAgentsHubContextType = useMemo(
    () => ({
      action,
      setAction,
    }),
    [action, setAction]
  );

  return (
    <AIAgentsHubContext.Provider value={value}>
      {children}
    </AIAgentsHubContext.Provider>
  );
};

export const useAIAgentsHub = (): AIAgentsHubContextType => {
  const context = useContext(AIAgentsHubContext);
  if (!context) {
    throw new Error('useAIAgentsHub must be used within a AIAgentsHubProvider');
  }
  return context;
};
